import React from "react";
import { formatCurrency } from "../../utils/numberFormatters";

interface ProgressBarProps {
  label: string;
  actual: number;
  total: number;
  actualGradientColor?: string;
  height?: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  label,
  actual,
  total,
  actualGradientColor = "#60e2e9",
  height,
}) => {
  const progress = Math.min((actual / total) * 100, 100);

  return (
    <div className="flex flex-col w-full">
      <div className="flex items-center w-full">
        <div className="w-4/5">
          <div className="w-full bg-[#F1F0F3] relative" style={{ height }}>
            <div
              className="border-2"
              style={{
                width: `${progress}%`,
                height: "100%",
                borderColor: actualGradientColor,
                backgroundImage: `linear-gradient(to right, white, ${actualGradientColor})`,
              }}
            />
          </div>
        </div>

        <div
          className="w-1/5 text-black font-semibold flex items-center justify-end"
          style={{ height: height || 20, fontSize: `${height && height < 16 ? height : 16}px` }}
        >
          {actual >= 0 ? `${formatCurrency(actual)}` : formatCurrency(actual)}
        </div>
      </div>

      <div className="text-[8px] text-[#48455B]">{label}</div>
    </div>
  );
};

export default ProgressBar;
